// search results: sections/predictive-search-json.liquid

import React, {useState, useEffect} from 'react';
// import axios from 'axios';
import PageInfoStore from './flux/PageInfoStore';
// import useDebounce from './hooks/useDebounce';

export default function MainNavSearchResults() {
  const searchURL = '/search?q=';
  const [searchValue, setSearchValue] = useState(PageInfoStore.getSearchTerm());
  const [searchResults, setSearchResults] = useState(PageInfoStore.getSearchResults());
  useEffect(() => {
    const emitter = PageInfoStore.addListener('searchResults', () => {
      setSearchValue(PageInfoStore.getSearchTerm());
      setSearchResults(PageInfoStore.getSearchResults());
      // console.log(PageInfoStore.getSearchResults());
    });
    return () => { emitter.remove() }
  });

  function renderProducts() {
    console.log(searchResults);
    return (
      <ul className="products">
        {searchResults.map((product) => {
          console.log(product);
          return (
            <li className="product">
              <a href={product.url}>
                <img src={product.image} className="thumbnail" />
                <h3>{product.title}</h3>
              </a>
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <div className="header-search-results">
      <div className="page-width">
        <div className="search-results-width">
          {searchResults.length > 0 ? renderProducts() : ''}        
          <a href={`${searchURL}${searchValue}`} className="see-more">
            <h2>See all results for "{searchValue}"</h2>
          </a>
        </div>
      </div>
    </div>
  )
}